import Phaser from 'phaser';
import { ATLAS_CONFIG } from '../consts/AtlasConfig';
import { SOUND_EFFECTS_ASSETS } from '../consts/SoundEffectsAssets';
import { SPRITE_SHEETS_ARRAY } from '../consts/SpriteSheets';
// import WebFont from 'webfont';

/**
 * This Scene is responsible for loading all game assets of the game.
 * While it is loading, it will present a progressbar with the loading progress.
 * @class
 */
export class PreloadScene extends Phaser.Scene {
  /**
   * This Scene is responsible for loading all game assets of the game.
   * While it is loading, it will present a progressbar with the loading progress.
   */
  constructor() {
    super({
      key: 'PreloadScene',
    });

    /**
     * The Progress Bar that will be updated with the current loading value.
     * @type { Phaser.GameObjects.Graphics }
     */
    this.progressBar = null;

    /**
     * The Background of the Progress Bar.
     * @type { Phaser.GameObjects.Graphics }
     */
    this.progressBox = null;

    /**
     * The curretn camera Width.
     * @type { numnber }
     */
    this.cameraWidth = 0;

    /**
     * The current camera Height.
     * @type { number }
     */
    this.cameraHeight = 0;

    /**
     * The loading text.
     * @type { Phaser.GameObjects.Text }
     */
    this.loadingText = null;

    /**
     * The percentage text.
     * @type { Phaser.GameObjects.Text }
     */
    this.percentText = null;

    /**
     * The current progress value.
     * @type { number }
     */
    this.currentValue = 0;

    /**
     * The Progressbar (background / box) tarting X position.
     * @type { number }
     */
    this.boxStartingX = 10;

    /**
     * The progressbar (background / box) height.
     * @type { number }
     */
    this.boxHeight = 50;
    /**
     * The progressbar (background / box) padding.
     * @type { number }
     */
    this.boxPadding = 30;

    /**
     * The progress (background / box) margin from the text.
     * @type { number }
     */
    this.boxMargin = 30;

    /**
     * The progress bar height.
     * @type { number }
     */
    this.barHeight = 30;

    /**
     * The progressbar starting X position.
     * @type { number }
     */
    this.barStartingX = 20;

    /**
     * The progressbar margin from the text.
     * @type { number }
     */
    this.barMargin = 40;

    /**
     * The scene that is loaded after the preload scene is done loading assets.
     * @type { string }
     * */
    this.AFTER_LOAD_SCENE = this.AFTER_LOAD_SCENE || 'MintingScene';

    /**
     * The array of images that will be loaded on this game. You can either use the image path or the imported image.
     * @example
     * [
     *   {
     *   name: 'image1',
     *   image: 'assets/images/image1.png',
     *   }
     *   {
     *   name: 'image1',
     *   image: 'https://myimageurl.com', // URL needs to enable CORS.
     *   }
     * ];
     * @type { array }
     * @default
     */
    this.SPRITE_SHEETS = SPRITE_SHEETS_ARRAY;

    this.nftIds = this.nftIds || [];
  }

  preload() {
    this.load.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js');
    // Images
    if (this.SPRITE_SHEETS) {
      this.SPRITE_SHEETS.forEach((values) => {
        this.load.image(values.name, values.image);
      });
    }

    if (SOUND_EFFECTS_ASSETS.length > 0) {
      SOUND_EFFECTS_ASSETS.forEach((sound) => {
        this.load.audio(sound.name, sound.file);
      });
    }
    // Atlas
    if (ATLAS_CONFIG.length > 0) {
      ATLAS_CONFIG.forEach((value) => {
        this.load.atlas(value.name, value.image, value.json);
      });
    }

    // Custom CSS
    // this.load.css('nescss', nesCss);
    this.progressBar = this.add.graphics();
    this.progressBox = this.add.graphics();
    this.cameraWidth = this.cameras.main.width;
    this.cameraHeight = this.cameras.main.height;

    this.rt = this.add.renderTexture(0, 0, this.cameraWidth, this.cameraHeight);
    this.rt.fill(0x000000, 0.3);

    this.progressBox.fillStyle(0x222222, 0.8);
    this.progressBox.fillRect(
      this.boxStartingX,
      this.cameraHeight / 2 + this.boxMargin,
      this.cameraWidth - this.boxPadding,
      this.boxHeight
    );

    this.loadingText = this.make.text({
      x: this.cameraWidth / 2,
      y: this.cameraHeight / 2 - this.boxHeight,
      text: 'Loading...',
      style: {
        font: '20px monospace',
        fill: '#ffffff',
      },
    });
    this.loadingText.setOrigin(0.5, 0.5);

    this.percentText = this.make.text({
      x: this.cameraWidth / 2,
      y: this.cameraHeight / 2 - 5,
      text: '0%',
      style: {
        font: '18px monospace',
        fill: '#ffffff',
      },
    });
    this.percentText.setOrigin(0.5, 0.5);
    this.load.on('progress', (value) => {
      this.currentValue = value;
      this.percentText.setText(parseInt(value * 100) + '%');
      this.progressBar.clear();
      this.progressBar.fillStyle(0xffffff, 1);
      this.progressBar.fillRect(
        this.barStartingX,
        this.cameraHeight / 2 + this.barMargin,
        (this.cameraWidth - this.boxHeight) * value,
        this.barHeight
      );
    });

    this.load.on('complete', () => {
      this.progressBar.destroy();
      this.progressBox.destroy();
      this.loadingText.destroy();
      this.percentText.destroy();
      this.rt.destroy();
      // this.scene.launch(this.AFTER_LOAD_SCENE);
      this.scene.stop();
    });
    this.scale.on('resize', (size) => {
      this.resize(size);
    });
  }

  create() {
    const Animations = [
      'gravestones/stage00/grave',
      'gravestones/stage01/grave',
      'gravestones/stage02/grave',
      'gravestones/stage03/grave',
      'gravestones/stage04/grave',
      'gravestones/stage05/grave',
      'gravestones/stage06/grave',
    ];
    Animations.forEach((animation, index) => {
      this.anims.create({
        key: animation + index,
        frameRate: 1,
        frames: this.anims.generateFrameNames('gravestones', {
          prefix: animation,
          start: 0,
          end: 0,
          zeroPad: 2,
        }),
        repeat: 0,
      });
    });

    this.anims.create({
      key: `btn_off`,
      frameRate: 1,
      frames: this.anims.generateFrameNames('background_button_toggle', {
        prefix: 'background_button/btn_off',
        start: 0,
        end: 0,
        zeroPad: 2,
      }),
      repeat: 0,
    });
    this.anims.create({
      key: `btn_on`,
      frameRate: 1,
      frames: this.anims.generateFrameNames('background_button_toggle', {
        prefix: 'background_button/btn_on',
        start: 0,
        end: 0,
        zeroPad: 2,
      }),
      repeat: 0,
    });

    // eslint-disable-next-line no-undef
    if (WebFont) {
      // eslint-disable-next-line no-undef
      WebFont.load({
        custom: {
          families: ['BlackBeard'],
        },
        active: () => {
          fetch(`${process.env.VUE_APP_SERVER_URI}/api/onis/${this.nftIds}`).then((res) => {
            res.json().then((data) => {
              this.scene.launch(this.AFTER_LOAD_SCENE, data);
            });
          });
        },
      });
    }
  }

  resize(size) {
    if (size) {
      this.cameraWidth = size.width;
      this.cameraHeight = size.height;

      this.rt.setPosition(0, 0);
      this.rt.width = this.cameraWidth;
      this.rt.height = this.cameraHeight;

      this.loadingText.setPosition(this.cameraWidth / 2, this.cameraHeight / 2 - this.boxHeight);
      this.percentText.setPosition(this.cameraWidth / 2, this.cameraHeight / 2 - 5);

      this.progressBox.clear();
      this.progressBox.fillStyle(0x222222, 0.8);
      this.progressBox.fillRect(
        this.boxStartingX,
        this.cameraHeight / 2 + this.boxMargin,
        this.cameraWidth - this.boxPadding,
        this.boxHeight
      );
      this.progressBar.clear();
      this.progressBar.fillStyle(0xffffff, 1);
      this.progressBar.fillRect(
        this.barStartingX,
        this.cameraHeight / 2 + this.barMargin,
        (this.cameraWidth - this.boxHeight) * this.currentValue,
        this.barHeight
      );
    }
  }
}
